import { Issue, OpEvent } from 'oneorm-api-http-client';

import { RiskCaseType, RiskCaseTypeParam } from '../../models/risk-case-type.model';

export const isEvent = (type: RiskCaseType | RiskCaseTypeParam): boolean => type === 'Event' || type === 'event';
export const isRiskCaseOpEvent = (riskCaseType: RiskCaseType | RiskCaseTypeParam, value: OpEvent | Issue): value is OpEvent =>
  riskCaseType === 'Event' || riskCaseType === 'event';
